// Inline field errors for the account forms (add/edit user, add admin, add client).
//
// The server rejects an email or username that another account already uses
// with HTTP 409 and { error, field: 'email' | 'username' }. getConflictField()
// tells the form which input to mark, so the message shows under that field
// instead of only in the page banner (which is hidden behind the open form).
import React from 'react';

// Same accent colour the app already uses for warnings.
const ERROR_COLOR = 'var(--color-accent)';

/** 'email' | 'username' if the error is a duplicate-account error, else null.
 *  Reads error.data.field, which apiFetchJSON attaches from the 409 response. */
export function getConflictField(error) {
    const field = error?.data?.field;
    return field === 'email' || field === 'username' ? field : null;
}

/** Style for an input that has an error. Merge into the input's style prop. */
export const invalidInputStyle = {
    borderColor: ERROR_COLOR,
    boxShadow: `0 0 0 1px ${ERROR_COLOR}`,
};

/** Error text shown directly under an input. Renders nothing without a message. */
export function FieldError({ message }) {
    if (!message) return null;
    return (
        <div
            role="alert"
            style={{ color: ERROR_COLOR, fontSize: '0.8rem', marginTop: 4, lineHeight: 1.3 }}
        >
            <i className="fas fa-exclamation-circle" style={{ marginRight: 4 }}></i>
            {message}
        </div>
    );
}
